import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import CustomCard from 'Components/Card';
import { Grid } from "@mui/material";
//Helpers
import { copyToClipboard } from 'Core/data/Helpers';

//Actions
import {
    rebootDeviceGetDeviceRequest,
    rebootDeviceOpenModal,
    rebootDeviceRequest,
    clearRedux,
} from 'Redux/actions';

const VIDFLEET_ERROR_CODES = {
    23: "common_authentication_failed",
    24: "",
    200: "common_camera_password_error",
    201: "common_camera_operation_failed",
    202: "common_camera_does_not_exist",
    204: "common_sync_camera_error",
    209: "common_camera_does_not_exist",
}

const RebootDevice = (props) => {
    const { single } = props;
    const formRef = useRef();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { messages } = useIntl();

    //Local States
    const [serial, setSerial] = useState("");

    //Redux States
    const { loading, openModal, result, devices, device } = useSelector(state => state.rebootDeviceRedux);

    const searchDevice = () => {
        let deviceValidation = devices.length ? devices.some((item) => item.esn === serial?.trim() || item.imei === serial?.trim()) : false
        if(deviceValidation){
            //error
            NotificationManager.warning(
                messages['send_commands_the_device_has_already_been_added'],
                single ? messages['reboot_device_title'] : messages['reboot_device_bulk_reboot'],
                3000
            );
        }
        else {
            dispatch(rebootDeviceGetDeviceRequest(serial?.trim()))
        }
    }

    const closeModal = () => {
        dispatch(clearRedux("REBOOT_DEVICE"));
    }

    const confirmReboot = () => {
        let ids = devices.map((item) => (item.id))
        dispatch(rebootDeviceRequest({ ids }));
    }

    useEffect(() => {
        if (result && !result?.error) {
            if (result?.result?.transactionId) {
                let message = messages['reboot_device_message_success']
                NotificationManager.success(message, single ? messages['reboot_device_title'] : message['reboot_device_bulk_reboot'], 10000, () => {
                    copyToClipboard(result?.result?.transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${result?.result?.transactionId}`);

                }, null, '', null);
                closeModal();
            } else {
                NotificationManager.error(
                    messages['reboot_device_sending_command_not_accepted'],
                    single ? messages['reboot_device_title'] : messages['reboot_device_bulk_reboot'],
                    3000
                );
            }
        } else if (result?.error) {
            let message = messages['reboot_device_error_sending_the_command'];
            if (result.error && result.error.code) {
                let messageKey = VIDFLEET_ERROR_CODES[result.error.code]
                if (!messageKey && messageKey !== "") {
                    message = messages[messageKey];
                } else {
                    message = result.error.msg
                }
            }
            //Error message
            NotificationManager.error(
                message,
                messages['reboot_device_title'],
                3000
            );
            closeModal();
        }
    }, [result])

    useEffect(() => {
        if (device) {
            if (!device?.total) {
                NotificationManager.warning(
                    messages['send_commands_the_device_has_not_been_found'],
                    single ? messages['reboot_device_title'] : messages['reboot_device_bulk_reboot'],
                    3000
                );
            } else {
                const { items } = device;
                let currentDevice = items[0]
                let deviceValidation = currentDevice.deviceModel.manufacturer.name === "VidFleet"
                if (deviceValidation) {
                    let currentDevices = devices
                    setSerial("");
                    currentDevices.push(currentDevice)
                    dispatch(rebootDeviceOpenModal(currentDevices));
                } else {
                    setSerial("");
                    NotificationManager.warning(
                        messages["devices_main_only_vidfleet"],
                        single ? messages['reboot_device_title'] : messages['reboot_device_bulk_reboot'],
                        5000
                    );
                }
            }
            dispatch(clearRedux("REBOOT_DEVICE", { device: null }));
        }
    }, [device])

    return (
        <Modal
            open={openModal}
            title={single ? messages['reboot_device_title'] : messages['reboot_device_bulk_reboot']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div>
                    {
                        !single &&
                        <div style={{ padding: '0 10px', marginBottom: 30 }}>
                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item xs={10}>
                                    <Form
                                        ref={formRef}
                                        onValidSubmit={() => searchDevice()}
                                    >
                                        <Input
                                            label={messages['send_commands_imei_or_serial']}
                                            placeholder={messages['send_commands_imei_or_serial']}
                                            required
                                            requiredMessage={messages['required_field']}
                                            value={serial}
                                            onChange={(value) => setSerial(value)}
                                            maxLength={20}
                                        />
                                    </Form>
                                </Grid>
                                <Grid item xs={2}>
                                    <div style={{ marginTop: 26 }}>
                                        <Button
                                            className="btn-dark-blue"
                                            onClick={() => formRef?.current?.submit()}
                                        >
                                            {messages['common_add']}
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                            {devices?.length > 0 ? devices.map((item, index) => {
                                return (
                                    <CustomCard
                                        key={index}
                                        onClick={() => {
                                            let currentDevices = devices;
                                            let selected = currentDevices.findIndex((device) => device.id === item.id);
                                            if (selected > -1) currentDevices.splice(selected, 1);
                                            dispatch(rebootDeviceOpenModal(currentDevices));
                                        }}
                                    >
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['send_commands_imei']}</label><span>{item?.imei}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['send_commands_serial']}</label><span>{item?.esn}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['send_commands_model']}</label><span>{item?.deviceModel?.name}</span>
                                            </div>
                                        </div>
                                    </CustomCard>
                                )
                            }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                        </div>
                    }
                    {
                        single &&
                        <div style={{ padding: '0 10px', marginBottom: 30 }}>
                            <label style={{ marginBottom: 5 }}>
                                {messages['reboot_device_label']}
                            </label>
                        </div>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => confirmReboot()}
                >
                    {messages['reboot_device_reboot']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default RebootDevice;